<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div class="d-flex justify-content-between align-items-center">
            <h4>Sổ văn bản</h4>
            <el-button
              class="btn-back"
              @click="fn_goBack"
              >Quay lại</el-button
            >
          </div>
          <div class="main-body mt-2">
            <div class="main-body-search">
              <!-- Thêm mới sổ văn bản -->
              <el-card class="box-card mb-3">
                <el-form
                  ref="formCreateDocumentTextBook"
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  @submit.native.prevent
                  label-width="145px"
                >
                  <b-row class="mb-3">
                    <h5>Thêm mới sổ văn bản</h5>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Tên sổ văn bản" prop="name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.name"
                          placeholder=""
                          clearable
                          ref="name"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="6">
                      <el-form-item label="Ký hiệu" prop="code">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.code"
                          placeholder=""
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Loại" prop="type">
                        <el-select v-model="mData.dataForm.type" filterable>
                          <el-option
                            v-for="item in mData.listType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Thứ tự hiển thị" prop="order">
                        <el-input-number
                          v-model.trim="mData.dataForm.order"
                          placeholder=""
                          clearable
                          :min="1"
                          controls-position="right"
                        ></el-input-number>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="10">
                      <el-form-item label="Đơn vị" prop="organization_model_id">
                        <el-select
                          v-model="mData.dataForm.organization_model_id"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="item in mData.listOrganization"
                            :key="item.id"
                            :label="
                              item.name ? item.name : 'Tổ chức không xác định'
                            "
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-button
                        class="btn-default w-100"
                        @click="fn_showTreeDetail"
                      >
                        Tìm kiếm
                      </el-button>
                    </b-col>
                  </b-row>
                  <div class="text-center mb-0">
                    <el-button
                      v-if="viewMode == 'create'"
                      class="btn-default"
                      @click="fn_submitForm('create')"
                      >Lưu</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-default"
                      @click="fn_submitForm('update')"
                      >Cập nhật</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-back"
                      @click="fn_cancelUpdate()"
                      >Hủy</el-button
                    >
                  </div>
                </el-form>
              </el-card>
              <!-- Danh mục sổ văn bản -->
              <h5 class="mb-1">Danh mục sổ văn bản</h5>
              <div class="main-body-table">
                <el-table
                  :data="mData.tableRules.data"
                  :border="true"
                  style="width: 100%"
                >
                  <el-table-column prop="" label="STT" width="45">
                    <template slot-scope="scope">
                      <div class="text-center">
                        {{ mData.tableRules.offset + scope.$index + 1 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Tên sổ văn bản"
                    min-width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="code"
                    label="Ký hiệu"
                    align="center"
                    min-width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="Loại"
                    align="center"
                    min-width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="organization_model_name"
                    label="Đơn vị"
                    align="center"
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.organization_model_name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.organization_model_name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="Thao tác" align="center">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('update', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_update"
                        type="primary"
                        :disabled="scope.row.is_default"
                      >
                        <i class="far fa-edit"></i>
                      </el-button>
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('delete', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_delete"
                        type="danger"
                        :disabled="scope.row.is_default"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                  <div class="col-md-4">
                    <!-- <div v-if="mData.tableRules.allowSelect">
                      {{ aLang.c_select }}:
                      {{ mData.tableRules.recordSelected.length }}
                    </div> -->
                  </div>
                  <div class="col-md-8 text-right">
                    <el-pagination
                      @size-change="fn_tableSizeChange"
                      @current-change="fn_tableCurentChange"
                      @prev-click="fn_tablePrevClick"
                      @next-click="fn_tableNextClick"
                      :page-sizes="mData.tableRules.lengthMenu"
                      :page-size="mData.tableRules.limit"
                      :current-page="mData.tableRules.page"
                      background
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="mData.tableRules.total"
                      :pager-count="5"
                    ></el-pagination>
                  </div>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog chọn đơn vị -->
    <el-dialog
      title="Tìm kiếm trong đơn vị"
      :visible.sync="formDialog"
      width="85%"
      top="5vh"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
    >
      <div>
        <el-form
          ref="formSearchOrganization"
          :model="mData.dataFormSearch"
          :rules="mData.validFormSearch"
          @submit.native.prevent
          label-width="72px"
          v-if="formDialog"
        >
          <div class="main-body-table">
            <b-row>
              <b-col md="5">
                <el-form-item label="Từ khóa" prop="">
                  <el-input
                    type="text"
                    v-model="filterText"
                    placeholder="Nhập tên đơn vị để tìm kiếm"
                  ></el-input>
                    <!-- @keyup.enter.native="fn_searchByName" -->
                </el-form-item>
                <!-- <b-col md="2">
              <el-button class="btn-default" @click="fn_searchByName"
                >Tìm kiếm</el-button
              >
            </b-col> -->
                <el-card class="box-card">
                  <el-tree
                    :data="mData.dataDefault.listOrganizationModelTree"
                    default-expand-all
                    node-key="id"
                    ref="tree"
                    highlight-current
                    :props="defaultProps"
                    :filter-node-method="fn_filterNode"
                  >
                  </el-tree>
                </el-card>
              </b-col>

              <b-col md="7">
                <div class="d-flex align-items-baseline">
                  <h6 class="mb-2 ml-2 mr-2">Danh sách đơn vị</h6>
                  <el-tooltip class="item" effect="light" placement="top-start">
                    <div slot="content" style="max-width: 200px">
                      Nhấn vào 1 bản ghi bất kỳ trên bảng để chọn đơn vị
                    </div>
                    <i class="fas fa-info-circle"></i>
                  </el-tooltip>
                </div>
                <el-table
                  :data="mData.listOrganization"
                  :border="true"
                  style="width: 100%"
                  max-height="450px"
                  highlight-current-row
                  @current-change="handleCurrentChange"
                >
                  <el-table-column prop="" label="STT" width="45">
                    <template slot-scope="scope">
                      <div class="text-center">
                        {{ mData.tableRules.offset + scope.$index + 1 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Tên đơn vị"
                    min-width="200"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="parent_name"
                    label="Đơn vị cha"
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.parent_name"
                      >
                        <span class="content" slot="reference">{{
                          scope.row.parent_name
                        }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
              </b-col>
            </b-row>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="text-center dialog-footer">
        <el-button class="btn-default" @click="fn_selectOrganization"
          >Đồng ý</el-button
        >
        <el-button class="btn-back" @click="fn_closeDialog">Đóng</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import CategoryManagementModel from "./CategoryManagementModel";
import BookApi from "../../../moduleApi/BookApi";
import OrganizationModelApi from "../../../moduleApi/OrganizationModelApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      currentUser: MethodService.getCurrentUser(),
      currentCompany: MethodService.getCompanyInfo(),
      viewMode: "create",
      formDialog: false,
      filterText: '',
      defaultProps: {
        children: "children",
        label: "label",
      },
      mData: {
        moduleName: "DocumentTextBook",
        tableRules: MethodService.copyObject(
          CategoryManagementModel.tableRules
        ),
        dataForm: MethodService.copyObject(CategoryManagementModel.dataForm),
        validForm: CategoryManagementModel.validForm,
        dataFormSearch: MethodService.copyObject(
          CategoryManagementModel.dataFormSearch
        ),
        validFormSearch: CategoryManagementModel.validFormSearch,
        dataDefault: {
          listOrganizationModelTree: [],
        },
        listType: [
          {
            label: "Văn bản đến",
            value: "DOCUMENT_IN",
          },
          {
            label: "Văn bản đi",
            value: "DOCUMENT_OUT",
          },
          {
            label: "Văn bản trình ký",
            value: "DOCUMENT_SIGN",
          },
        ],
        listOrganization: [],
        listParentOrganization: [],
      },
    };
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    fn_filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    async fn_getListOrganizationModelTree() {
      const organizationApiRes = await OrganizationModelApi.list({
        limit: 9999,
      });
      if (organizationApiRes.result) {
        this.mData.listParentOrganization = [
          {
            id: this.currentCompany.id,
            name: this.currentCompany.name.name_vi,
          },
          ...organizationApiRes.result,
        ];
        this.mData.listOrganization = await this.fn_matchData(organizationApiRes.result);

        // console.log('this.mData.listOrganization', this.mData.listOrganization);
        // console.log('this.mData.listParentOrganization', this.mData.listParentOrganization);
        let result = organizationApiRes.result;
        let treeList = [];
        // Get all parent
        let parents = result.filter((r) => r.parent_id == null);
        // console.log("Parents", parents);
        if (parents != null && parents.length > 0) {
          parents.forEach((organization1) => {
            let obj = {
              id: organization1.id,
              label: organization1.name
                ? organization1.name
                : "Tổ chức không xác định",
              children: [],
            };
            // Get child of parent
            const childs = result.filter((r) => r.parent_id == obj.id);
            // console.log("childs", childs);
            if (childs != null && childs.length > 0) {
              childs.forEach((element) => {
                obj.children.push({
                  id: element.id,
                  label: element.name ? element.name : "Tổ chức không xác định",
                  children: this.fn_getTreeByRecursion(element, result),
                });
              });
            }
            treeList.push(obj);
          });
        }
        this.mData.dataDefault.listOrganizationModelTree = treeList;
        // console.log("DATA", treeList);
      }
    },

    fn_getTreeByRecursion(child, rootArr) {
      let childrenArr = rootArr.filter((r) => r.parent_id == child.id);
      if (!childrenArr || childrenArr.length == 0) return [];
      let root = childrenArr.map((organization1) => {
        let obj = {
          id: organization1.id,
          label: organization1.name ? organization1.name : "Không xác định",
          children: [],
        };
        obj.children = this.fn_getTreeByRecursion(organization1, rootArr);
        return obj;
      });
      return root;
    },

    fn_matchData(data) {
      data.forEach((item) => {
        item.name = item.name ? item.name : "Tên không xác định";
        if (item.parent_id) {
          const o = this.mData.listParentOrganization.find(
            (o) => o.id == item.parent_id
          );
          item.parent_name = o ? o.name : "Đơn vị cha không xác định";
        }
      });
      return data;
    },

    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.page = this.mData.tableRules.page;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-CategoryManagement-" + this.mData.moduleName,
            query: {
              ...dataFilter,
            },
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      const documentTextBookApiRes = await BookApi.list(dataFilter);
      this.mData.tableRules.total = documentTextBookApiRes.meta.total;
      if (
        documentTextBookApiRes.result &&
        documentTextBookApiRes.result.length > 0
      ) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
        this.mData.tableRules.data = await this.fn_changeData(
          documentTextBookApiRes.result
        );
      } else {
        this.mData.tableRules.data = [];
      }
      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        await this.fn_initTable();
      }
    },

    async fn_getDataById(id, organizationName) {
      // this.mData.dataFormSearch.keyName = organizationName;
      // await this.fn_searchByName();
      const documentTextBookApiRes = await BookApi.findById(id);
      if (documentTextBookApiRes.result) {
        this.mData.dataForm = documentTextBookApiRes.result;
      }
    },

    fn_handle(type, scope, row) {
      if (type == "update") {
        this.viewMode = "update";
        this.fn_resetForm();
        this.fn_getDataById(row.id, row.organization_model_name);
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    fn_closeDialog() {
      this.formDialog = false;
    },

    handleCurrentChange(val) {
      this.mData.dataForm.organization_model_id = val.id;
    },

    fn_selectOrganization() {
      if (this.mData.dataForm.organization_model_id) {
        this.formDialog = false;
        return;
      }
      window.toastr.warning("Vui lòng chọn một đơn vị bất kỳ");
    },

    fn_showTreeDetail() {
      this.formDialog = true;
      // this.fn_getListOrganizationModelTree();
    },

    async fn_searchByName() {
      try {
        const dataSearch = this.mData.dataFormSearch;
        let query = {
          company_id: this.currentCompany.id,
        };
        if (dataSearch.keyName) {
          query.words = MethodService.changeAlias(dataSearch.keyName).split(
            " "
          );
        } else {
          query.words = [];
        }
        const organizationApiRes =
          await OrganizationModelApi.SearchOrganizationModels(query);
        if (organizationApiRes.result) {
          this.mData.listOrganization = organizationApiRes.result.lst;
        }
      } catch (error) {
        this.mData.listOrganization = [];
        console.log("Error", error);
      }
    },

    fn_changeData(data) {
      data.forEach((item) => {
        item.organization_model_name = this.currentCompany.name.name_vi;
        item.type =
          item.type == "DOCUMENT_IN"
            ? "Văn bản đến"
            : item.type == "DOCUMENT_OUT"
            ? "Văn bản đi"
            : item.type == "DOCUMENT_SIGN"
            ? "Văn bản trình ký"
            : "";
      });
      return data;
    },

    fn_submitForm(type) {
      this.$refs["formCreateDocumentTextBook"].validate(async (valid) => {
        if (valid) {
          try {
            let data = this.mData.dataForm;
            data.name = data.name ? data.name.trim() : "";
            data.code = data.code ? data.code.trim() : "";
            data.order = data.order ? data.order : 1;
            data.year = new Date().getFullYear();
            if (type == "create") {
              await BookApi.create(data);
            } else if (type == "update") {
              await BookApi.update(data);
            }
            this.fn_resetForm();
            await this.fn_initTable();
            this.viewMode = "create";
          } catch (error) {
            if (error.code == 500) {
              this.$refs.name.focus();
              window.toastr.error("Sổ văn bản đã tồn tại");
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_delete(id) {
      await BookApi.delete(id);
      await this.fn_initTable();
      this.fn_cancelUpdate();
    },

    fn_cancelUpdate() {
      this.fn_resetForm();
      this.viewMode = "create";
    },

    fn_resetForm() {
      this.$refs["formCreateDocumentTextBook"].resetFields();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
    },

    fn_goBack() {
      this.$router.go(-1);
    }
  },
  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable();
    this.fn_getListOrganizationModelTree();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-tree {
  max-height: 383px;
  overflow: auto;
}
label .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep .current-row {
  td {
    background: #ffd4d4 !important;
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
</style>
